module.exports = __webpack_public_path__ + "img/ico_feed_luckydraw@3x.b31cdc57.png";